import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import Routes from '../../routes';

export default class StreetView extends Component {

  DEFAULT_ZOOM = 18;

  DEFAULT_HEADING = 0;

  DEFAULT_PITCH = 0;

  DEFAULT_RADIUS = 200;

  _id = null;

  _options = null;

  _element = null;

  _service = null;

  _instance = null;

  events = {};

  constructor(App, namespace, id, options) {
    super(...arguments);

    this.id = id;
    this.options = options;
    this.configure();
    this.initialize();
  }

  configure() {
    this.service = new google.maps.StreetViewService();
    return super.configure();
  }

  initialize() {
    this.start();
    return super.initialize();
  }

  set id(value) {
    this._id = value;
  }

  get id() {
    return this._id;
  }

  set options(value) {
    this._options = value;
  }

  get options() {
    return this._options;
  }

  set element(value) {
    this._element = value;
  }

  get element() {
    return this._element;
  }

  set service(value) {
    this._service = value;
  }

  get service() {
    return this._service;
  }

  set instance(value) {
    this._instance = value;
  }

  get instance() {
    return this._instance;
  }

  start() {

    // Create map instance
    this.map = new google.maps.Map(document.getElementById(this.id.map),
      $.extend({
          // center: {lat: options.config.map.center[1], lng: options.config.map.center[1]},
          zoom:   this.DEFAULT_ZOOM
        },
        this.options.config.map || {}
      )
    );

    // Create street view instance
    this.view = new google.maps.StreetViewPanorama(
      document.getElementById(this.id.view),
      $.extend({
          /*
          position: {lat: options.config.view.position[1], lng: options.config.view.position[1]},
          pov: {
            heading: defaultHeading,
            pitch:   defaultPitch
          },
          */
          enableCloseButton: false,
          zoomControl:       false
        },
        this.options.config.view || {}
      ));

    this.map.setStreetView(this.view);

    this.proxyEvents();
  }

  proxyEvents() {

    this.view.addListener('pano_changed', () => {

      this.logger('Pano changed to:', this.view.getPano());

      return this.searchById(this.view.getPano(), (result) => {
        this.dispatch('panoChanged', (result.isByUser ? result.id : null));
      });

    });

    this.view.addListener('position_changed', () => {
      let position = {
        lat: this.view.getPosition().lat().toFixed(6),
        lng: this.view.getPosition().lng().toFixed(6)
      };

      this.logger('Position changed to:', position);
      this.dispatch('positionChanged', position);
    });

    this.view.addListener('pov_changed', () => {
      let heading = this.view.getPov().heading.toFixed(2);
      let pitch   = this.view.getPov().pitch.toFixed(2);

      this.logger('Point of view changed to:', heading, 'heading and', pitch, 'pitch');

      this.dispatch('headingChanged', heading);
      this.dispatch('pitchChanged',   pitch);
    });

  }

  addListener (event, callback) {
    // Check if the callback is not a function
    if (typeof callback !== 'function') {
      this.logger('The listener callback must be a function, the given type is '+ typeof callback);
      return false;
    }

    // Check if the event is not a string
    if (typeof event !== 'string') {
      this.logger('The event name must be a string, the given type is '+ typeof event);
      return false;
    }

    // Create the event if not exists
    if (this.events[event] === undefined) {
      this.events[event] = {
        listeners: []
      }
    }

    this.events[event].listeners.push(callback);
  }

  dispatch (event, data) {
    // Check if this event not exists
    if (this.events[event] === undefined) {
      return false;
    }

    this.events[event].listeners.forEach(function(listener) {
      listener(data);
    });
  }

  /**
   * Searches panorama by location
   *
   * @param location
   * @param callback
   * @returns {*}
   */
  searchByLocation(location, callback) {
    let query = {
      location: location,
      radius:   this.DEFAULT_RADIUS
    };

    return this.search(query, callback);
  }

  /**
   * Searches panorama by id
   *
   * @param id
   * @param callback
   * @returns {*}
   */
  searchById(id, callback) {
    let query = {
      pano: id
    };

    return this.search(query, callback);
  }

  /**
   * Searches panorama by body query
   *
   * @param query
   * @param callback
   * @returns {*}
   */
  search(query, callback) {
    return this.service.getPanorama(query, (data, status) => {

      this.logger('getPanorama result:', status, data);

      let result = null;

      if (status === google.maps.StreetViewStatus.OK) {

        result = {
          id:       data.location.pano,
          isByUser: (typeof data.location.profileUrl === 'string'),
          position: {
            lat: data.location.latLng.lat(),
            lng: data.location.latLng.lng()
          },
          heading: this.DEFAULT_HEADING,
          pitch:   this.DEFAULT_PITCH
        };

      } else if (status === google.maps.StreetViewStatus.ZERO_RESULTS) {
        this.App.UI.Dialog.alert(
          this.App.Language.get('errors.zero_results')
        );
      } else {
        this.App.UI.Dialog.alert(
          this.App.Language.get('errors.external_error')
        );
      }

      this.logger('getPanorama compiled result:', result);

      return callback(result);
    });
  }

  setId(id) {
    this.view.setPano(id);
    setTimeout(() => {
      return this.refresh();
    }, 1000);
  }

  setPosition(location) {
    this.map.setCenter(location);
    this.view.setPosition(location);
    setTimeout(() => {
      return this.refresh();
    }, 1000);
  }

  /**
   * Sets heading
   *
   * @param heading
   */
  setHeading(heading) {
    this.setPOV(
      heading,
      this.view.getPov().pitch
    );
  }

  /**
   * Sets pitch
   *
   * @param pitch
   */
  setPitch(pitch) {
    this.setPOV(this.view.getPov().heading, pitch);
  }

  /**
   * Sets point of view
   *
   * @param heading
   * @param pitch
   */
  setPOV(heading, pitch) {
    this.view.setPov({
      heading: heading,
      pitch:   pitch
    });
  }

  /**
   * Sets panorama visibility
   *
   * @param visibility
   */
  setVisible(visibility) {
    this.view.setVisible(visibility);
  }

  /**
   * Sets map's center
   *
   * @param location
   */
  setCenter(location) {
    this.map.setCenter(location);
  }

  /**
   * Computes heading
   *
   * @param point1
   * @param point2
   * @returns {*}
   */
  computeHeading(point1, point2) {

    return google.maps.geometry.spherical.computeHeading(
      new google.maps.LatLng(point1),
      new google.maps.LatLng(point2)
    );

  }

  /**
   * Trigger `resize` event for google.maps
   */
  refresh() {
    google.maps.event.trigger(this.map,  'resize');
    google.maps.event.trigger(this.view, 'resize');
    this.setVisible(true);
  }

}